export default __webpack_public_path__ + "static/media/756-mark.480fd21f.svg";